import {
  InsuranceMonitor,
  InsurancePolicyType
} from "@wingspanhq/wingspan-api-sdk";

/**
 * The policy types a monitor requires, as **wire values**.
 *
 * Every consumer feeds these into `getRequirementDefinitionTemplateByParams`,
 * which matches `TEMPLATES` by wire value (`"GeneralLiability"`) and supplies
 * the human-readable name itself — so this must not pre-format them.
 *
 * The requirements live on the monitor's `InsuranceMonitorConfiguration`
 * (`coverages[].policyType`) rather than on the monitor itself — one
 * configuration backs many monitors — so the read must have been made with
 * `expand[]=Configuration` (see `INSURANCE_MONITOR_EXPAND`). A configuration
 * may accept more than one policy type, where the pre-3.13.0 monitor carried
 * a single inline `coverageType`.
 */
export const selectorPolicyTypesFromMonitor = (
  monitor: InsuranceMonitor | undefined
): InsurancePolicyType[] =>
  (monitor?._configuration?.coverages ?? [])
    .map(coverage => coverage.policyType)
    .filter((policyType): policyType is InsurancePolicyType => !!policyType);
